import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { useTranslation, withTranslation } from 'react-i18next';
import { AlertNotice, Input } from 'shared/components';
import { every, find, isEmpty, isNull, isUndefined, orderBy } from 'lodash';
import { capacityDisplayLogic } from 'shared/helpers';
import { LOCATION_EVENT_STATUS, TIMING_CATEGORIES_NAME } from 'shared/constants';
import './CapacityTab.scss';
import BuildingIcon from 'assets/svgs/buildingIconBlack.svg';
import LocationOpenCloseIcon from 'assets/svgs/openCloseLocation.svg';
import { calculateTotal, calculateNewTotal } from '../../helpers';

const checkNumber = (e) => {
  const keyCode = e.keyCode || e.which;
  const keyValue = String.fromCharCode(keyCode);
  const isValid = new RegExp('[0-9]').test(keyValue);

  //This condition checks if the selected value is equal to the input value. If they are equal, the input will accept a new value even if the event.target.length is larger than 3
  if (document.getSelection().toString() === document.getElementById('newCapacity').value) {
    return true;
  }

  if (!isValid || e.target.value.length > 3) {
    e.preventDefault();
    return false;
  }
};

const isLocationOpen = (locationCapacities, location) =>
  ((isEmpty(locationCapacities) || !locationCapacities.status) &&
    location.locationEvent.status !== LOCATION_EVENT_STATUS.closed) ||
  (!isEmpty(locationCapacities) &&
    ((locationCapacities.status &&
      locationCapacities.status.toUpperCase() !== LOCATION_EVENT_STATUS.closed) ||
      !locationCapacities.status));

class CapacityTab extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { capacityTypes, locations, locationEvents, tcEvent, onChange, onToggleLocation } =
      this.props;

    const totalCapacity = calculateTotal(locationEvents, locations, capacityTypes);
    const totalNewCapacity = calculateNewTotal(locationEvents, locations, capacityTypes);

    return (
      <div className="capacity-tab">
        <h5>{tcEvent.testingEvent.name}</h5>

        <div className="capacity-header">
          <div className="fw-bold">{this.props.t('requestUpdate.capacity.totalTitle')}</div>
          <div>
            {this.props.t('requestUpdate.capacity.totalLabel')}: {totalCapacity}
            {totalCapacity !== totalNewCapacity && (
              <span className="new-total">
                {this.props.t('common.labels.new')}: {totalNewCapacity}
              </span>
            )}
          </div>
        </div>

        {every(locations, (location) => {
          const locationEvent = find(locationEvents, { locationId: location.id });
          return isEmpty(locationEvent)
            ? location.locationEvent.status === LOCATION_EVENT_STATUS.closed
            : locationEvent.status &&
                locationEvent.status.toUpperCase() === LOCATION_EVENT_STATUS.closed;
        }) && (
          <AlertNotice message={this.props.t('requestUpdate.capacity.allLocationClosedInfo')} />
        )}

        {!!locations.length ? (
          <div>
            {locations.map((location, idx) => {
              const locationCapacities = find(locationEvents, { locationId: location.id });

              return (
                <div key={`location-${idx}`} className="location-capacities">
                  <div
                    className={`location ${
                      !isLocationOpen(locationCapacities, location) ? 'closed' : ''
                    }`}>
                    <div className="location-title">
                      <BuildingIcon />
                      <span>
                        {location.name}
                        {location.area && location.area.length > 0 && `, ${location.area}`}
                      </span>
                    </div>
                    {isLocationOpen(locationCapacities, location) ? (
                      locations.length > 1 && (
                        <a className="location-close" onClick={() => onToggleLocation(location.id)}>
                          <LocationOpenCloseIcon className="show-mobile" />{' '}
                          {this.props.t('requestUpdate.capacity.closeLabel')}{' '}
                          <LocationOpenCloseIcon className="hide-mobile" />
                        </a>
                      )
                    ) : (
                      <a className="location-open" onClick={() => onToggleLocation(location.id)}>
                        <LocationOpenCloseIcon /> {this.props.t('requestUpdate.capacity.openLabel')}
                      </a>
                    )}
                  </div>
                  {isLocationOpen(locationCapacities, location) &&
                    orderBy(capacityTypes, 'displayOrder', 'asc').map((type, i) => {
                      const capacityType = capacityDisplayLogic(location, type, true);

                      let capacityTypeOtherLocation = false;
                      if (!capacityType.capacity) {
                        locations.map((loc) => {
                          if (
                            loc.id != location.id &&
                            location.locationEvent &&
                            location.locationEvent.locationEventCapacities
                          ) {
                            if (
                              find(
                                loc.locationEvent.locationEventCapacities,
                                (locCapacity) => locCapacity.capacityType.id === type.id
                              )
                            ) {
                              capacityTypeOtherLocation = true;
                            }
                          }
                        });
                      }

                      let newCapacity = '';
                      if (!isEmpty(locationCapacities)) {
                        newCapacity =
                          find(locationCapacities.capacities, { capacityTypeId: type.id }) || '';
                      }

                      return (
                        ((!isNull(capacityType.capacity) && !!capacityType.capacity) ||
                          capacityTypeOtherLocation) && (
                          <CapacityRow
                            title={type.name}
                            assigned={capacityType.assigned}
                            current={capacityType.capacity}
                            newCapacity={newCapacity.capacity}
                            newCapacityValue={newCapacity.capacityValue}
                            onChange={onChange}
                            locationId={location.id}
                            capacityTypeId={type.id}
                            capacityTypeTiming={type.timing}
                            key={`capacity-type-${i}`}
                          />
                        )
                      );
                    })}
                </div>
              );
            })}
          </div>
        ) : (
          <AlertNotice message={this.props.t('testCenter.eventDashboard.noLocationsLabel')} />
        )}
      </div>
    );
  }
}

const CapacityRow = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <h6>{props.title}</h6>
      <div className="capacity-row">
        <Input
          type="number"
          readOnly={true}
          name="assigned"
          value={props.assigned}
          label={t('requestUpdate.capacity.assignedLabel')}
          onChange={() => {}}
        />

        <span>{t('requestUpdate.capacity.outOfLabel')}</span>

        <Input
          type="number"
          readOnly
          name="current"
          label={t('requestUpdate.capacity.currentLabel')}
          value={props.current}
          onChange={() => {}}
        />

        <Input
          type="number"
          value={!isUndefined(props.newCapacity) ? props.newCapacity : ''}
          name="newCapacity"
          label={t('requestUpdate.capacity.newCapacityLabel')}
          containerClassName={`${!!props.newCapacity ? 'new-capacity' : ''}`}
          onChange={(e) => props.onChange(e, props.locationId, props.capacityTypeId)}
          onBlur={(e) => props.onChange(e, props.locationId, props.capacityTypeId, true)}
          onKeyPress={checkNumber}
        />

        {((!!props.newCapacityValue && !!props.newCapacity && props.newCapacity < props.assigned) ||
          (props.newCapacityValue > 0 && props.newCapacityValue < 5)) && (
          <div className="capacity-warning">
            {props.newCapacityValue > 0 &&
              props.newCapacityValue < 5 &&
              props.capacityTypeTiming === TIMING_CATEGORIES_NAME.extended && (
                <div>{t('requestUpdate.capacity.minimumCapacityWarning')}</div>
              )}
            {!!props.newCapacityValue &&
              !!props.newCapacity &&
              props.newCapacity < props.assigned &&
              t('requestUpdate.capacity.newCapacityIsLower')}
          </div>
        )}
      </div>
    </>
  );
};

export default withTranslation()(CapacityTab);
CapacityTab.propTypes = {
  capacityTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  locations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  tcEvent: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  onToggleLocation: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

CapacityTab.defaultProps = {};
